// @ts-nocheck

import { type Cashout } from '../states/cashout';
import { CashoutActionTypes } from '../types/actions/cashout';

const initialState: Cashout = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case CashoutActionTypes.CASHOUT_REQUEST:
      return {
        ...state,
        [action.payload.id]: false,
      };
    case CashoutActionTypes.CASHOUT_FAIL:
      return {
        ...state,
        [action.payload.id]: null,
      };
    case CashoutActionTypes.CASHOUT_SUCCESS:
      return {
        ...state,
        [action.payload.id]: true,
      };
    default:
      return state;
  }
};
